// This file needs to import from react-router since it's the abstraction
import { withSentryReactRouterV6Routing } from '@sentry/react';
/* eslint-disable no-restricted-imports */
import {
  BrowserRouter,
  Route,
  Routes,
  MemoryRouter,
  Navigate,
  Outlet,
} from 'react-router-dom';

export { BrowserRouter, Route, Routes, MemoryRouter, Navigate, Outlet };
export type { NavigateProps } from 'react-router-dom';

// Sentry-instrumented Routes for top-level route trees only.
// withSentryReactRouterV6Routing hooks into reactRouterV6BrowserTracingIntegration
// to emit a navigation span on every client-side route change.
//
// IMPORTANT: Use only at the top level of a route tree. Nested <Routes> components
// (e.g. admin-settings sub-routers) must use the plain Routes export to avoid
// last-writer-wins transaction name conflicts.
export const SentryRoutes = withSentryReactRouterV6Routing(Routes);
